/*
 * @Author: 戴旭
 * @Date: 2023-02-17 11:10:33
 * @LastEditTime: 2023-02-17 14:14:17
 * @LastEditors: 戴旭
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\bonus-computed\bonus-scheme\moudels\dataPretreatmentRouter.js
 * 数据预处理
 */
const dataPretreatmentRouter = [
  // 数据预处理
  // meta: 1数据预处理  2奖金计算  3支付计算
  {
    path: '/bonusReturnSystem/data-pretreatment/:meta_type',
    name: 'bonusReturnSystemDataPretreatment',
    component: () =>
      import(
        /*webpackChunkName:"bonusReturnSystemDataPretreatment" */
        '@/views/bonus-computed/bonus-scheme/data-pretreatment/data-pretreatment/Page.vue'
      ),
    meta: {
      SecondaryMenu: '数据预处理', //二级菜单
      isMoreMeta: true,
      1: {
        title: '数据预处理'
      },
      2: {
        title: '奖金计算'
      },
      3: {
        title: '支付计算'
      }
    }
  },

  // 数据预处理 方案设计
  {
    path: '/bonusReturnSystem/scheme-design/:meta_type/:id',
    name: 'bonusReturnSystemSchemeDesign',
    component: () =>
      import(
        /*webpackChunkName:"bonusReturnSystemCategory" */
        '@/views/bonus-computed/bonus-scheme/data-pretreatment/data-pretreatment/Design.vue'
      ),
    meta: {
      SecondaryMenu: '数据预处理', //二级菜单
      isMoreMeta: true,
      1: {
        title: '方案设计',
        breadcrumb: [
          {
            title: '数据预处理',
            name: 'bonusReturnSystemDataPretreatment'
          }
        ]
      },
      2: {
        title: '方案设计',
        breadcrumb: [
          {
            title: '奖金计算',
            name: 'bonusReturnSystemDataPretreatment'
          }
        ]
      },
      3: {
        title: '方案设计',
        breadcrumb: [
          {
            title: '支付计算',
            name: 'bonusReturnSystemDataPretreatment'
          }
        ]
      }
    }
  },

  // 数据预处理 方案计算
  {
    path: '/bonusReturnSystem/scheme-operation/:meta_type/:id',
    name: 'bonusReturnSystemSchemeOperation',
    component: () =>
      import(
        /*webpackChunkName:"bonusReturnSystemCategory" */
        '@/views/bonus-computed/bonus-scheme/data-pretreatment/data-pretreatment/compute/Page.vue'
      ),
    meta: {
      SecondaryMenu: '数据预处理', //二级菜单
      isMoreMeta: true,
      1: {
        title: '方案计算',
        breadcrumb: [
          {
            title: '数据预处理',
            name: 'bonusReturnSystemDataPretreatment'
          }
        ]
      },
      2: {
        title: '方案计算',
        breadcrumb: [
          {
            title: '奖金计算',
            name: 'bonusReturnSystemDataPretreatment'
          }
        ]
      },
      3: {
        title: '方案计算',
        breadcrumb: [
          {
            title: '支付计算',
            name: 'bonusReturnSystemDataPretreatment'
          }
        ]
      }
    }
  },

  // 数据预处理 方案计算 结果
  {
    path: '/bonusReturnSystem/calculate-result/:meta_type/:id/:scheme_id',
    name: 'bonusReturnSystemCalculateResult',
    component: () =>
      import(
        /*webpackChunkName:"bonusReturnSystemCategory" */
        '@/views/bonus-computed/bonus-scheme/data-pretreatment/data-pretreatment/compute/Result.vue'
      ),
    meta: {
      SecondaryMenu: '数据预处理', //二级菜单
      isMoreMeta: true,
      1: {
        title: '计算结果',
        breadcrumb: [
          {
            title: '数据预处理',
            name: 'bonusReturnSystemDataPretreatment'
          },
          {
            title: '方案计算',
            name: 'bonusReturnSystemSchemeOperation'
          }
        ]
      },
      2: {
        title: '计算结果',
        breadcrumb: [
          {
            title: '奖金计算',
            name: 'bonusReturnSystemDataPretreatment'
          },
          {
            title: '方案计算',
            name: 'bonusReturnSystemSchemeOperation'
          }
        ]
      },
      3: {
        title: '计算结果',
        breadcrumb: [
          {
            title: '支付计算',
            name: 'bonusReturnSystemDataPretreatment'
          },
          {
            title: '方案计算',
            name: 'bonusReturnSystemSchemeOperation'
          }
        ]
      }
    }
  },

  // 数据预处理 方案计算 日志
  {
    path: '/bonusReturnSystem/log/:meta_type/:id/:scheme_id',
    name: 'bonusReturnSystemLog',
    component: () =>
      import(
        /*webpackChunkName:"bonusReturnSystemCategory" */
        '@/views/bonus-computed/bonus-scheme/data-pretreatment/data-pretreatment/compute/Log.vue'
      ),
    meta: {
      SecondaryMenu: '数据预处理', //二级菜单
      isMoreMeta: true,
      1: {
        title: '日志',
        breadcrumb: [
          {
            title: '数据预处理',
            name: 'bonusReturnSystemDataPretreatment'
          },
          {
            title: '方案计算',
            name: 'bonusReturnSystemSchemeOperation'
          }
        ]
      },
      2: {
        title: '日志',
        breadcrumb: [
          {
            title: '奖金计算',
            name: 'bonusReturnSystemDataPretreatment'
          },
          {
            title: '方案计算',
            name: 'bonusReturnSystemSchemeOperation'
          }
        ]
      },
      3: {
        title: '日志',
        breadcrumb: [
          {
            title: '支付计算',
            name: 'bonusReturnSystemDataPretreatment'
          },
          {
            title: '方案计算',
            name: 'bonusReturnSystemSchemeOperation'
          }
        ]
      }
    }
  },

  // 数据预处理 方案计算 编写取数逻辑列表
  {
    path: '/bonusReturnSystem/redact-number-logic-list/:meta_type/:schemeId/:resultId',
    name: 'bonusReturnSystemRedactNumberLogicList',
    component: () =>
      import(
        /*webpackChunkName:"bonusReturnSystemCategory" */
        '@/views/bonusReturnSystem/RedactNumberLogicList.vue'
      ),
    meta: {
      SecondaryMenu: '数据预处理', //二级菜单
      isMoreMeta: true,
      1: {
        title: '编写取数逻辑列表',
        breadcrumb: [
          {
            title: '数据预处理',
            name: 'bonusReturnSystemDataPretreatment'
          },
          {
            title: '方案计算',
            name: 'bonusReturnSystemSchemeOperation'
          }
        ]
      },
      2: {
        title: '编写取数逻辑列表',
        breadcrumb: [
          {
            title: '奖金计算',
            name: 'bonusReturnSystemDataPretreatment'
          },
          {
            title: '方案计算',
            name: 'bonusReturnSystemSchemeOperation'
          }
        ]
      },
      3: {
        title: '编写取数逻辑列表',
        breadcrumb: [
          {
            title: '支付计算',
            name: 'bonusReturnSystemDataPretreatment'
          },
          {
            title: '方案计算',
            name: 'bonusReturnSystemSchemeOperation'
          }
        ]
      }
    }
  },

  //  数据预处理 方案计算 编写取数逻辑列表 编写
  {
    path: '/bonusReturnSystem/redact-number-logic/:meta_type/:resultId/:numberId/:schemeId',
    name: 'bonusReturnSystemRedactNumberLogic',
    component: () =>
      import(
        /*webpackChunkName:"bonusReturnSystemCategory" */
        '@/views/bonus-computed/bonus-scheme/data-pretreatment/data-pretreatment/compute/write/Write.vue'
      ),
    meta: {
      SecondaryMenu: '数据预处理', //二级菜单
      isMoreMeta: true,
      1: {
        title: '编写取数逻辑',
        breadcrumb: [
          {
            title: '数据预处理',
            name: 'bonusReturnSystemDataPretreatment'
          },
          {
            title: '方案计算',
            name: 'bonusReturnSystemSchemeOperation'
          },
          {
            title: '编写取数逻辑列表',
            name: 'bonusReturnSystemRedactNumberLogicList'
          }
        ]
      },
      2: {
        title: '编写取数逻辑',
        breadcrumb: [
          {
            title: '奖金计算',
            name: 'bonusReturnSystemDataPretreatment'
          },
          {
            title: '方案计算',
            name: 'bonusReturnSystemSchemeOperation'
          },
          {
            title: '编写取数逻辑列表',
            name: 'bonusReturnSystemRedactNumberLogicList'
          }
        ]
      },
      3: {
        title: '编写取数逻辑',
        breadcrumb: [
          {
            title: '支付计算',
            name: 'bonusReturnSystemDataPretreatment'
          },
          {
            title: '方案计算',
            name: 'bonusReturnSystemSchemeOperation'
          },
          {
            title: '编写取数逻辑列表',
            name: 'bonusReturnSystemRedactNumberLogicList'
          }
        ]
      }
    }
  }
]

export default dataPretreatmentRouter
